import script from "./TinyMce.vue?vue&type=script&lang=ts&setup=true"
export * from "./TinyMce.vue?vue&type=script&lang=ts&setup=true"

import "./TinyMce.vue?vue&type=style&index=0&id=65508496&lang=css"

const __exports__ = script;

export default __exports__